import React from "react";
import Footer from "../../components/Footer";
import Individual from "./IndividualView";

export function IndividualContainer() {
  return (
    <div>
      <Individual title="Contact"/>
      <Footer/>
    </div>
  );
}
